module.exports = __webpack_public_path__ + "img/body-cream.19c7f3fa.svg";